<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="card shadow-sm">
            <div class="card-body">
              <h1 class="h4 mb-2">Sign In</h1>
              <p class="help mb-3">
                Login with your account.
              </p>

              <form @submit.prevent="handleLogin">
                <div class="mb-3">
                  <label class="form-label">Username</label>
                  <input v-model="form.username" type="text" class="form-control" autocomplete="username" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Password</label>
                  <input v-model="form.password" type="password" class="form-control" autocomplete="current-password"
                    required />
                </div>

                <div v-if="error" class="alert alert-danger py-2">
                  {{ error }}
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                  <RouterLink to="/signup" class="small">Need an account?</RouterLink>
                  <button type="submit" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    Sign In
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { APIService } from "../http/APIService";

export default {
  name: "LoginView",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      loading: false,
      error: null,
      api: new APIService(),
    };
  },
  methods: {
    async handleLogin() {
      this.error = null;
      this.loading = true;
      try {
        const res = await this.api.login({
          username: this.form.username,
          password: this.form.password,
        });
        const { access, refresh } = res.data;
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);

        const accountRes = await this.api.account(access);
        localStorage.setItem("currentUser", JSON.stringify(accountRes.data));

        this.$router.push({ name: "Dashboard" });
      } catch (err) {
        this.error =
          err.response?.data?.detail ||
          "Unable to sign in. Check your credentials and try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.help {
  color: #6c757d;
}
</style>
